import React from "react";
import { connect } from 'react-redux';
import ContactForm from "./ContactForm";
import * as Yup from "yup";
import * as actions from './store/contactActions';
import History from "../../../../History";
import { hasPermission, parseURL } from "../../../sc-utilities";

const ContactCreate = props => {
    const { activeCustomerID, translations, permissions, createContact } = props;
    const searchParams = parseURL(window.location.href)

    const handleSubmit = async data => {
        let formData = { ...data };
        let result = await createContact({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        FirstName: "",
        LastName: "",
        CompanyName: "",
        PhoneNumber: "",
        Email: ""
    };

    let formSettings = {
        Validation: {
            FirstName: Yup.string().required("Required"),
            LastName: Yup.string().required("Required"),
            CompanyName: Yup.string().required("Required"),
            PhoneNumber: Yup.string().required("Required"),
            Email: Yup.string().required("Required")
        },
        FormTitle: translations["create_contact"] || "Create contact",
        ButtonSubmit: hasPermission(permissions, 'contact_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };
    return (
        <ContactForm
            formSettings={formSettings}
            initialValues={initialValues}
            handleSubmit={handleSubmit}
            translations={translations}
        />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createContact: data => dispatch(actions.createContact(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactCreate);
